import React from "react";
import { bool, elementType, oneOf, oneOfType, string } from "prop-types";
import forwardRefPropType from "../utils/forward-ref";
import { classes } from "../utils/classes";

const NavbarItem = ({
	Tag = "li",
	forwardRef,
	itemIcon,
	enable = true,
	secondary = false,
	className,
	...props
}) =>
	enable ? (
		<Tag
			ref={forwardRef}
			className={classes(
				secondary && "secondary-nav__item",
				secondary && itemIcon && `secondary-nav__item-${itemIcon}`,
				className,
			)}
			{...props}
		/>
	) : null;

NavbarItem.propTypes = {
	Tag: oneOfType([oneOf(["li"]), elementType]),
	itemIcon: oneOf(["search"]),
	enable: bool,
	secondary: bool,
	className: string,
	forwardRef: forwardRefPropType,
};

export default NavbarItem;
